import styled from 'styled-components';

// import colors from 'utils/style/colors';
import { black, blue, gray, white, whitesmoke } from 'utils/style/colors';

import { Avatar } from '../../../HomePage/styles';

export const HeaderContent = styled('div')`
  display: flex;
  flex-direction: column;
  padding: 0.8rem 1.5rem;
`;

export const ToolbarIconWithTitle = styled('div')`
  display: flex;
  align-items: center;
`;

export const AvatarAndNameWrapper = styled('div')`
  align-items: center;
  display: flex;
  flex-direction: column;
  padding-top: 0.4rem;
`;

export const UserAvatar = styled(Avatar)`
  height: 5.3rem !important;
  width: 5.3rem !important;
`;
interface NameProps {
  white?: boolean;
}
export const Name = styled('div')<NameProps>`
  color: ${(props) => (props.white ? white : black)};
  font-size: 2rem;
  font-weight: 400;
  margin-top: 0.6rem;
  text-align: center;
  ${(props) =>
    props.white
      ? `
  // background: #7570703b;
  padding: 5px 10px;
  border-radius: 16rem;`
      : ''}
`;

export const UserField = styled('div')`
  color: ${black};
  font-size: 0.9rem;
  margin-top: 0.25rem;
`;

export const Biography = styled('div')`
  color: ${gray};
  font-size: 0.8rem;
  line-height: 1.2rem;
  margin-top: 0.6rem;
  white-space: pre-line;
`;

export const Location = styled('div')`
  align-items: center;
  display: flex;
  flex-direction: row;
  margin-top: 0.5rem;
  svg {
    height: 1rem !important;
    width: 1rem !important;
  }
  span {
    color: ${black};
    font-size: 0.7rem;
    margin-right: 0.5rem;
  }
`;

export const WrokingContext = styled('div')`
  align-items: center;
  flex-direction: row;
  margin-top: 0.5rem;
  color: ${(props) => (props.white ? whitesmoke : gray)};
  font-size: 0.7rem;
  margin-right: 0.5rem;
  ${(props) =>
    props.white
      ? `
  background: #7570703b;
  padding: 5px 10px;
  border-radius: 16rem;`
      : ''}
`;

export const LinksWrapper = styled('div')`
  align-items: center;
  display: flex;
  flex-direction: row;
  height: 3.2rem;
  justify-content: flex-end;
  button,
  a {
    flex-basis: 33%;
    text-align: center;
  }
  svg {
    height: 1.25rem !important;
    width: 1.25rem !important;
  }
  .Mui-disabled {
    cursor: not-allowed;
    opacity: 0.45;
  }
`;

export const ContactDialogContent = styled('div')`
  align-items: center;
  display: flex;
  flex-direction: column;
  min-width: 18rem;
  overflow-y: auto;
  overflow-y: overlay;
`;

export const ContactDialogTitle = styled('div')`
  color: ${gray};
  font-size: 1.3rem;
  margin-top: 1.87rem;
`;

export const ContactPhoneList = styled('div')`
  align-items: center;
  display: flex;
  flex-direction: column;
  margin-top: 1.8rem;
  width: 100%;
  a {
    text-decoration: none;
    color: #6d6d6d;
  }
`;

export const ContactPhoneItem = styled('div')`
  align-items: center;
  display: flex;
  flex-direction: row;
  font-size: 1rem;
  justify-content: space-between;
  margin: 0.5rem 0;
  padding: 0.5rem 0;
  label {
    margin-left: 0.7rem;
  }
  .number {
    direction: ltr;
  }
`;

// export const Banner = styled('img')`
//   width: 100%;
//   height: 400px;
//   position: absolute;
//   left: 0;
//   right: 0;
//   top: 0;
//   z-index: -1;
//   object-fit:cover
//   // clip-path: ellipse(20% 80% at 30%);
//   border-radius:  0 0 50% 50% / 100%;
// `;
export const Banner = styled('img')`
  width: 100%;
  height: ${({ small }) => (small ? '350px' : '450px')};
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  z-index: -1;
  object-fit: cover;
  @media (max-width: 500px) {
    clip-path: ${({ small }) =>
      small ? 'circle(121% at 50% -68vw)' : 'circle(128% at 50% -68vw)'};
  }
  @media (min-width: 500px) {
    clip-path: ${({ small }) =>
      small ? 'circle(220% at 50% -145vw)' : 'circle(200% at 50% -127vw)'};
  }
`;

export const ContactPhoneDivider = styled('div')`
  background-color: ${blue};
  height: 1px;
  width: 100%;
`;
